const DEFAULT_CONFIGS = {
  api_url: import.meta.env.REACT_APP_MEETINGS_NEW_URL,
  file_url: import.meta.env.REACT_APP_PATIENT_NEW_URL,
  doctor_url: import.meta.env.REACT_APP_DOCTOR_URL,
  patient_url: import.meta.env.REACT_APP_PATIENT_URL,
  sentry_dsn: import.meta.env.REACT_APP_SENTRY_DSN,
  env: import.meta.env.MODE,
} as const;

const config = {
  production: DEFAULT_CONFIGS,
  development: {
    // PROD
    // api_url: "https://api-meeting.medicusunion.com",
    // file_url: "https://gateway.medicusunion.com",
    // doctor_url: "https://doctor.medicusunion.com",
    // patient_url: "https://medicusunion.com",
    ...DEFAULT_CONFIGS,
    // STAGING
    // api_url: "https://stg-api-meeting.medicusunion.me",
    // file_url: "https://stg-gateway.medicusunion.me",
    // doctor_url: "https://stg-doctor.medicusunion.me",
    // patient_url: "https://stg.medicusunion.me",
  },
  test: DEFAULT_CONFIGS
} as const;

export default import.meta.env.MODE in config ? config[import.meta.env.MODE as keyof typeof config] : config.development;
